module.exports = __webpack_public_path__ + "img/kangmingjian_img9.ba19181c.jpg";